import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import Datepicker from '../../../../../../common/inputs/datepicker/Datepicker'

const FreeFromToUntil: React.FC<FieldProps<CostsScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()
  const changeDates = useCallback(
    (_name: string, startDate?: Date, endDate?: Date) => {
      onChange({ screen: screenName, property: 'freeFrom' }, startDate)
      onChange({ screen: screenName, property: 'freeUntil' }, endDate)
    },
    [screenName, onChange]
  )
  const defaultMinDate = useMemo(() => new Date(), [])
  return (
    <div className={wrapperClassName}>
      <Datepicker
        id='free-from-to-until'
        propertyName='freeFrom'
        errors={[]}
        selectedDate={insertionData.freeFrom}
        dateRange={true}
        selectedEndDate={insertionData.freeUntil}
        defaultCancelBehaviour={true}
        minDate={defaultMinDate}
        labelTranslationKey='wizard.screen.costs.freeFromToUntil'
        placeholder={t('wizard.screen.costs.date', 'Date')}
        onChange={changeDates}
      />
    </div>
  )
}

export default FreeFromToUntil
